export default {
    title: 'Chữ cơ bản',

    level: {
        format: 'Cấp độ {level}',
        nextLevel: 'Cấp độ tiếp theo',
        currentLevel: 'Cấp độ hiện tại',
    },

    session: {
        count: '{count} lần',
        exam: 'Bài kiểm tra nhỏ',
        examScore: '{score} điểm',
        study: 'Học tập',
        completed: 'Hoàn thành',
        locked: 'Đã khóa',
        inProgress: 'Đang tiến hành',
    },

    navigation: {
        toWaitingRoom: 'Đi đến Phòng chờ',
        toStudy: 'Bắt đầu học',
        toExam: 'Bắt đầu kiểm tra',
        continue: 'Tiếp tục',
        stop: 'Dừng lại',
    },

    study: {
        start: 'Bắt đầu',
        continue: 'Tiếp tục',
        complete: 'Hoàn thành',
        stop: 'Dừng lại',
        stopConfirm: 'Bạn có thực sự muốn dừng học không?',
        example: 'Ví dụ',
        meaning: 'Nghĩa',
        sound: 'Âm thanh',
        listen: 'Nghe âm thanh',
    },

    exam: {
        start: 'Bắt đầu',
        grade: 'Chấm điểm',
        result: 'Xem kết quả',
        questions: {
            intro: 'Bắt đầu câu hỏi',
            upper: 'Câu hỏi chữ trên',
            lower: 'Câu hỏi chữ dưới',
        },
    },

    modal: {
        studyComplete: {
            title: 'Hoàn thành học tập',
            message: 'Chúc mừng! Bạn đã hoàn thành học tập.',
        },
        examComplete: {
            title: 'Hoàn thành kiểm tra',
            message: 'Bài kiểm tra đã hoàn thành.',
        },
        stopConfirm: {
            title: 'Dừng học tập',
            message: 'Bạn có thực sự muốn dừng học không?<br/>Tiến trình có thể không được lưu.',
        },
    },

    errors: {
        audioPlay: 'Đã xảy ra sự cố khi phát âm thanh',
        loadData: 'Đã xảy ra lỗi trong quá trình tải dữ liệu',
    },
};
